import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export const AboutUs3 = () => {
    useEffect(() => {
        AOS.init({
            duration: 900,
            easing: "ease-out-cubic",
            once: false,
        });
    }, []);

    return (
        <section id="features" className="py-5" style={{ backgroundColor: "#ffffff" }}>
            <div className="container text-center">
                {/* Tag */}
                <div
                    className="d-inline-block mb-3 px-3 py-1 rounded-pill border"
                    style={{
                        backgroundColor: "#ffffff",
                        boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                    }}
                    data-aos="fade-up"
                >
                    <span className="fw-bold text-dark">Who Biblivium Is For</span>
                </div>

                {/* Heading */}
                <h2
                    className="mb-3 fw-bold"
                    style={{ maxWidth: "700px", margin: "0 auto" }}
                    data-aos="fade-up"
                    data-aos-delay="100"
                >
                    Whether you are a lifelong reader or just beginning your journey into global literature, Biblivium offers a calm space to discover, learn, and connect.
                </h2>

                <div className="row py-5"
                    style={{
                        background: "#ffffff",
                        borderRadius: "10px",
                        border: "1px solid #fff",
                        boxShadow:
                            "0px 2px 10px rgba(28,28,28,0.08), inset 0 -6px 6px rgba(255,255,255,0.2)",
                    }} >

                    <div className="col-md-6">

                        {/* Subtitle */}
                        <h4
                            className="text-muted mb-2 py-5"
                            style={{ maxWidth: "700px", margin: "0 auto" }}
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            Biblivium is for readers who:
                        </h4>
                        <p
                            className="text-muted mb-3"
                            style={{ maxWidth: "700px", margin: "0 auto" }}
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            - Value depth without academic density
                        </p>
                        <p
                            className="text-muted mb-3"
                            style={{ maxWidth: "700px", margin: "0 auto" }}
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            - Want to explore literature beyond their native language
                        </p>
                        <p
                            className="text-muted mb-3"
                            style={{ maxWidth: "700px", margin: "0 auto" }}
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            - Prefer thoughtful curation over algorithmic overload
                        </p>
                        <p
                            className="text-muted mb-3"
                            style={{ maxWidth: "700px", margin: "0 auto" }}
                            data-aos="fade-up"
                            data-aos-delay="200"
                        >
                            - Believe reading is a way to understand the world
                        </p>
                    </div>

                    <div className="col-md-6">
                        <img
                            src="/media/reading.jpg"
                            alt="About Us"
                            className="img-fluid rounded-4 shadow-sm mb-4"
                            data-aos="zoom-in"
                            data-aos-delay="300"
                        />
                    </div>
                </div>
            </div>
            <div className="row justify-content-center pt-5" style={{ width: "300px", alignItems: "center", margin: "0 auto" }}>
                <div className="col" xs="auto">
                    <div
                        className="d-flex align-items-center gap-2 px-3 py-2"
                        data-aos="fade-up"
                        style={{
                            background: "#ffffff",
                            borderRadius: "100px",
                            border: "1px solid #fff",
                            boxShadow:
                                "0px 2px 10px rgba(28,28,28,0.08), inset 0 -6px 6px rgba(255,255,255,0.2)",
                        }}
                    >
                        <span className="text-dark" style={{ fontSize: 14 }}>
                            Globally curated. Elegantly presented.
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
};
